// import React, { useState, useEffect } from 'react';
// import { Box, Typography, TextField, Button } from '@mui/material';
// import axios from 'axios';
// // import { apiUrl } from '../../../api';
// import api from '../../services/api';

// const DealDrawer = ({ deal, onClose, onSaved, pipelineId }) => {
//     const [form, setForm] = useState({
//         title: deal.title || '',
//         value: deal.value || 0,
//         contact_name: deal.contact_name || '',
//         description: deal.description || ''
//     });
//     const [saving, setSaving] = useState(false);
//     const [appId, setAppId] = useState(null);

//     //  pegar app padrão
//     const pegar_app_padrao = async () => {
//         try {
//             const response = await api.get('v1/apps/default/');
//             setAppId(response.data.app.id);
//         } catch (error) {
//             console.error(error);
//         }
//     };

//     useEffect(() => {
//         pegar_app_padrao();
//     }, []);

//     //  só busca user quando tiver appId
//     useEffect(() => {
//         if (!appId) return;
//     }, [appId]);

//     const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

//     const save = async () => {
//         setSaving(true);
//         try {
//             const response = await api.patch(`v1/apps/${appId}/pipelines/${pipelineId}/deals/${deal.id}/`, form);
//             const data = response.data;

//             console.log(data);

//             if (onSaved) {
//                 onSaved();
//             }

//             onClose();
//         } catch (error) {
//             console.error(error);
//         } finally {
//             setSaving(false);
//         }

//     };

//     const deleteDeal = async () => {
//         setSaving(true);
//         try {
//             const response = await api.delete(`v1/app/${appId}/pipelines/${pipelineId}/deals/${deal.id}/`, form);
//             const data = response.data;

//             console.log(data);

//             if (onSaved) {
//                 onSaved();
//             }

//             onClose();
//         } catch (error) {
//             console.error(error);
//         } finally {
//             setSaving(false);
//         }
//     };

//     return (
//         <Box>
//             <Typography variant="h6" gutterBottom>
//                 {deal.title}
//             </Typography>

//             <TextField name="title" label="Título" value={form.title} onChange={handleChange} fullWidth sx={{ mb: 2 }} />
//             <TextField name="value" label="Valor" value={form.value} onChange={handleChange} fullWidth sx={{ mb: 2 }} />
//             <TextField name="contact_name" label="Contato" value={form.contact_name} onChange={handleChange} fullWidth sx={{ mb: 2 }} />
//             <TextField
//                 name="description"
//                 label="Descrição"
//                 value={form.description}
//                 onChange={handleChange}
//                 fullWidth
//                 multiline
//                 rows={4}
//                 sx={{ mb: 2 }}
//             />

//             <Box display="flex" justifyContent="flex-end" gap={1}>
//                 <Button
//                     onClick={onClose}
//                     variant="contained"
//                     sx={{
//                         backgroundColor: '#6faba0',
//                         textTransform: 'none'
//                     }}
//                 >
//                     Fechar
//                 </Button>
//                 <Button
//                     onClick={deleteDeal}
//                     variant="contained"
//                     sx={{
//                         backgroundColor: '#ad8578',
//                         textTransform: 'none'
//                     }}
//                 >
//                     Apagar
//                 </Button>
//                 <Button
//                     onClick={save}
//                     variant="contained"
//                     disabled={saving}
//                     sx={{
//                         backgroundColor: '#32CD32',
//                         textTransform: 'none'
//                     }}
//                 >
//                     Salvar
//                 </Button>
//             </Box>
//         </Box>
//     );
// };

// export default DealDrawer;

import React, { useEffect, useMemo, useState } from 'react';
import { Box, Typography, TextField, Button, Divider } from '@mui/material';
import api from '../../services/api';
import RelatedTicketsSection from '../ticket/RelatedTicketsSection';

const glassFieldSx = {
    mb: 2,
    '& .MuiOutlinedInput-root': {
        borderRadius: '18px',
        color: 'rgba(255,255,255,0.92)',
        background: 'linear-gradient(180deg, rgba(17,30,48,0.78), rgba(8,18,32,0.72))',
        backdropFilter: 'blur(16px)',
        boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.04), 0 0 0 1px rgba(110,220,255,0.08)',
        '& fieldset': {
            borderColor: 'rgba(110,220,255,0.14)'
        },
        '&:hover fieldset': {
            borderColor: 'rgba(110,220,255,0.28)'
        },
        '&.Mui-focused fieldset': {
            borderColor: 'rgba(124,232,255,0.55)',
            boxShadow: '0 0 18px rgba(0,204,255,0.12)'
        }
    },
    '& .MuiInputLabel-root': {
        color: 'rgba(255,255,255,0.60)'
    },
    '& .MuiInputLabel-root.Mui-focused': {
        color: 'rgba(180,245,255,0.90)'
    },
    '& .MuiOutlinedInput-input': {
        color: 'rgba(255,255,255,0.92)'
    }
};

const actionButtonSx = {
    borderRadius: '16px',
    px: 2.2,
    py: 1.1,
    textTransform: 'none',
    fontWeight: 500,
    color: '#eefcff',
    border: '1px solid rgba(120,220,255,0.18)',
    background: 'linear-gradient(180deg, rgba(42,92,132,0.80), rgba(18,42,66,0.88))',
    boxShadow: '0 0 18px rgba(0,183,255,0.08), inset 0 1px 0 rgba(255,255,255,0.08)',
    '&:hover': {
        background: 'linear-gradient(180deg, rgba(56,120,170,0.90), rgba(24,54,85,0.96))',
        boxShadow: '0 0 24px rgba(0,183,255,0.16)'
    }
};

const DealDrawer = ({ deal, onClose, onSaved, pipelineId }) => {
    const [form, setForm] = useState({
        title: deal?.title || '',
        value: deal?.value || 0,
        contact_name: deal?.contact_name || '',
        description: deal?.description || ''
    });

    const [saving, setSaving] = useState(false);
    const [appId, setAppId] = useState(null);

    const title = useMemo(() => form.title || deal?.title || 'Negócio', [form.title, deal]);

    const pegar_app_padrao = async () => {
        try {
            const response = await api.get('v1/apps/default/');
            setAppId(response.data.app.id);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        pegar_app_padrao();
    }, []);

    useEffect(() => {
        setForm({
            title: deal?.title || '',
            value: deal?.value || 0,
            contact_name: deal?.contact_name || '',
            description: deal?.description || ''
        });
    }, [deal]);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const save = async () => {
        if (!appId || !deal?.id) return;
        setSaving(true);

        try {
            const response = await api.patch(`v1/apps/${appId}/pipelines/${pipelineId}/deals/${deal.id}/`, form);

            console.log(response.data);

            if (onSaved) onSaved();
            if (onClose) onClose();
        } catch (error) {
            console.error(error);
        } finally {
            setSaving(false);
        }
    };

    const deleteDeal = async () => {
        if (!appId || !deal?.id) return;
        setSaving(true);

        try {
            const response = await api.delete(`v1/apps/${appId}/pipelines/${pipelineId}/deals/${deal.id}/`);

            console.log(response.data);

            if (onSaved) onSaved();
            if (onClose) onClose();
        } catch (error) {
            console.error(error);
        } finally {
            setSaving(false);
        }
    };

    return (
        <Box
            sx={{
                minHeight: '100%',
                p: 3,
                color: 'rgba(255,255,255,0.92)',
                background: `
                    radial-gradient(circle at 18% 10%, rgba(0,175,255,0.14), transparent 24%),
                    radial-gradient(circle at 85% 15%, rgba(0,110,255,0.10), transparent 22%),
                    linear-gradient(180deg, #07111b 0%, #040a12 100%)
                `
            }}
        >
            <Box
                sx={{
                    borderRadius: '28px',
                    p: 3,
                    border: '1px solid rgba(110,220,255,0.14)',
                    background: 'linear-gradient(180deg, rgba(8,20,34,0.84), rgba(5,12,22,0.92))',
                    backdropFilter: 'blur(16px)',
                    boxShadow: '0 0 42px rgba(0,160,255,0.10), inset 0 0 40px rgba(80,190,255,0.03), inset 0 1px 0 rgba(255,255,255,0.05)'
                }}
            >
                <Typography
                    variant="overline"
                    sx={{
                        color: 'rgba(157,236,255,0.84)',
                        letterSpacing: '0.18em',
                        display: 'block',
                        mb: 1
                    }}
                >
                    Event
                </Typography>

                <Typography
                    variant="h4"
                    sx={{
                        fontWeight: 500,
                        mb: 0.5,
                        color: 'rgba(255,255,255,0.94)'
                    }}
                >
                    {title}
                </Typography>

                <Typography
                    variant="body2"
                    sx={{
                        color: 'rgba(255,255,255,0.55)',
                        mb: 3
                    }}
                >
                    Edite os dados do negócio neste painel.
                </Typography>

                <Divider sx={{ borderColor: 'rgba(110,220,255,0.10)', mb: 3 }} />

                <TextField name="title" label="Título" value={form.title} onChange={handleChange} fullWidth sx={glassFieldSx} />

                <TextField name="value" label="Valor" value={form.value} onChange={handleChange} fullWidth sx={glassFieldSx} />

                <TextField
                    name="contact_name"
                    label="Contato"
                    value={form.contact_name}
                    onChange={handleChange}
                    fullWidth
                    sx={glassFieldSx}
                />

                <TextField
                    name="description"
                    label="Descrição"
                    value={form.description}
                    onChange={handleChange}
                    fullWidth
                    multiline
                    rows={5}
                    sx={glassFieldSx}
                />

                {appId && deal?.id && (
                    <Box sx={{ mb: 2 }}>
                        <RelatedTicketsSection appId={appId} dealId={deal.id} contactId={deal?.user} organizationId={deal?.organization} />
                    </Box>
                )}

                <Box display="flex" justifyContent="flex-end" gap={1.2} mt={2}>
                    <Button onClick={onClose} variant="contained" sx={actionButtonSx}>
                        Fechar
                    </Button>

                    <Button
                        onClick={deleteDeal}
                        variant="contained"
                        sx={{
                            ...actionButtonSx,
                            background: 'linear-gradient(180deg, rgba(117,59,71,0.82), rgba(61,25,33,0.92))',
                            '&:hover': {
                                background: 'linear-gradient(180deg, rgba(142,72,88,0.92), rgba(77,31,42,0.98))',
                                boxShadow: '0 0 24px rgba(255,90,120,0.14)'
                            }
                        }}
                    >
                        Apagar
                    </Button>

                    <Button
                        onClick={save}
                        variant="contained"
                        disabled={saving}
                        sx={{
                            ...actionButtonSx,
                            background: 'linear-gradient(180deg, rgba(86,214,255,0.95), rgba(36,110,170,0.92))',
                            color: '#04101a',
                            '&:hover': {
                                background: 'linear-gradient(180deg, rgba(122,228,255,1), rgba(46,135,196,0.98))',
                                boxShadow: '0 0 30px rgba(79,219,255,0.28)'
                            }
                        }}
                    >
                        Salvar
                    </Button>
                </Box>
            </Box>
        </Box>
    );
};

export default DealDrawer;